<template>
    <v-container>
        <v-simple-table class="px-8">
            
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Quadro de funcionários</v-toolbar-title>
                </v-toolbar>
                <v-divider class="mt-0 mb-5"></v-divider>
            </template>
            
            <template v-slot:default>
                <thead style="background-color:#F5F5F9;">
                    <tr>
                        <th style="color:#6C7293">Bases</th>
                        <th class="text-left" style="color:#6C7293" v-for="(header,index) in headersStaff" :key="index">{{header}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in basesStaff" :key="item.name">
                        <td v-for="staff in item" :key="item[staff]" style="color:#6C7293">
                            <span :class="staff === item.name ? 'font-weight-bold':''">{{ staff }}</span>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </v-container>
</template>

<script>
export default {
    computed:{
        headersStaff(){
            let nursingStaff = this.$store.getters.nursingStaff
            return nursingStaff.reduce((headers,nurse)=>{
                if(headers.indexOf(nurse.occupation) == -1)
                    headers.push(nurse.occupation)
                return headers
            },[])
        },
        basesStaff(){
            let nursingStaff = this.$store.getters.nursingStaff
            let reduced = nursingStaff.reduce((bases,nurse)=>{
                if(!bases[nurse.base]){
                  bases[nurse.base] = this.initializeStaffInBases(nurse.base) 
                }
                if(!bases[nurse.base][nurse.occupation]) bases[nurse.base][nurse.occupation] = 0
                bases[nurse.base][nurse.occupation] += 1
                
                return bases
            },{})

            return reduced
        }
    },
    methods:{
        initializeStaffInBases(name){
            return this.headersStaff.reduce((baseStaff,header)=>{
                baseStaff[header] = 0
                return baseStaff
            },{name:name})
        }
    }
}
</script>

<style>
</style>